// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card[data-v-e4f37794]{width:700px;background-color:#fff}.card[data-v-e4f37794]:hover{background-color:#f0f8ff}.strongText[data-v-e4f37794]{color:#8237dc}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
